<!--
 * @Author: your name
 * @Date: 2020-11-08 22:39:33
 * @LastEditTime: 2020-12-25 17:14:40
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /mall-wap-vue/src/views/order/orderpay/index.vue
-->
<template>
  <div>
    <title-bar-back :title="$G('az收银台')" @back="back">
      <div class="title_right"></div>
    </title-bar-back>
    <div class="pay_con">
      <money />
      <div class="pay_type">
        <div>
          <img src="@/assets/order/wechart@2x.png" alt="" class="wechat_icon" />
          <span class="font12 font_weight400 colo0 line_height_17 wechat_font"
            >微信支付</span
          >
        </div>
        <img
          :src="choose ? select : unSelect"
          alt=""
          class="select_icon"
          @click="clickChoose"
        />
      </div>
      <div
        v-if="getUserOrder.remainingTime"
        class="save_btn font_weight500 font14 colof line_height_20"
        @click="goPay"
      >
        确认支付
      </div>
    </div>
  </div>
</template>

<script>
const wx = require("jweixin-module");
import { v1 as uuidv1 } from "uuid";
import wechat from "@/utils/wechat";
import md5 from "js-md5";
const TitleBarBack = () =>
  import("@/components/TitleBarBack").then((m) => m.default || m);
import Money from "./components/Money";
export default {
  name: "OrderPay",
  components: {
    TitleBarBack,
    Money,
  },
  data() {
    return {
      unSelect: require("@/assets/login/unselect@2x.png"),
      select: require("@/assets/login/select@2x.png"),
      choose: true,
    };
  },
  computed: {
    getUserOrder() {
      return this.$store.getters.getUserOrder;
    },
  },
  // created() {
  //   this.getData();
  // },
  created() {
    this.getData();
    const query = this.$route.query;
    if (query.code && query.code !== localStorage.WECHAT_PAY_CODE) {
      // console.log(1111);
      localStorage.WECHAT_PAY_CODE = query.code;
      this.$store
        .dispatch("order/paymentPage", {
          params: {
            orderSn: query.orderSn,
            code: query.code,
            kind: 5,
          },
        })
        .then((response) => {
          const self = this;
          // 方法1
          this.$store
            .dispatch("order/jsticket", {
              params: {
                url: encodeURIComponent(window.location.href),
              },
            })
            .then((res1) => {
              // console.log("----", res1);
              self.$store.dispatch("load/setCode", {
                code: 1,
              });
              wx.config({
                debug: false,
                appId: res1.appId,
                timestamp: res1.timestamp,
                nonceStr: res1.nonceStr,
                signature: res1.signature,
                jsApiList: ["chooseWXPay"],
              });
              wx.ready(() => {
                self.$toast.clear();
                wx.chooseWXPay({
                  timestamp: response.timeStamp,
                  nonceStr: response.nonceStr,
                  package: response.package,
                  signType: response.signType,
                  paySign: response.paySign,
                  success() {
                    // 支付成功后的回调函数
                    const secretKey = "a02ade6080c33cf74a39fe1a387f956a";
                    // const secretKey = "e4059f3a0079d26316461f334931bbf1";
                    const random = uuidv1();
                    const md5Str =
                      secretKey +
                      "orderSn" +
                      query.orderSn +
                      "random" +
                      random +
                      secretKey;
                    // console.log(md5Str, "md5Str");
                    const sign = md5(md5Str);
                    const data = {
                      orderSn: query.orderSn,
                      random,
                      sign,
                    };
                    // console.log(data, "paySuccessd data");
                    self.$store
                      .dispatch("order/paySuccessd", {
                        params: data,
                      })
                      .then(() => {
                        // console.log("order/paySuccessd");
                        self.$store.dispatch("load/setCode", {
                          code: 1,
                        });
                        self.$router.push({
                          path: "/order/orderresult",
                          query: {
                            orderSn: query.orderSn,
                          },
                        });
                      })
                      .catch(() => {
                        self.$store.dispatch("load/setCode", {
                          code: 1,
                        });
                        self.$router.push({
                          path: "/order/orderresult",
                          query: {
                            orderSn: query.orderSn,
                          },
                        });
                      });
                  },
                  fail() {
                    self.$store.dispatch("load/setCode", {
                      code: 1,
                    });
                    self.$toast("支付失败");
                    const host = window.location.host;
                    window.location.replace(
                      `https://${host}${self.$route.path}?orderSn=${query.orderSn}`
                    );
                  },
                  cancel() {
                    self.$store.dispatch("load/setCode", {
                      code: 1,
                    });
                    self.$toast("支付失败");
                    const host = window.location.host;
                    window.location.replace(
                      `https://${host}${self.$route.path}?orderSn=${query.orderSn}`
                    );
                  },
                });
              });
              wx.error((res) => {
                self.$store.dispatch("load/setCode", {
                  code: 1,
                });
                self.$toast.fail(res);
              });
            })
            .catch();
        })
        .catch(() => {
          this.$toast("支付失败！");
          const host = window.location.host;
          window.location.replace(
            `https://${host}${this.$route.path}?orderSn=${this.$route.query.orderSn}`
          );
        });
    }
  },
  methods: {
    // getUserOrder
    // 获取数据
    getData() {
      const params = {
        orderSn: this.$route.query.orderSn,
      };
      this.$store
        .dispatch("order/getUserOrder", { params })
        .then(() => {})
        .catch(() => {});
    },
    back() {
      this.$router.push({
        path: "/order/detail",
        query: {
          orderSn: this.$route.query.orderSn,
        },
      });
    },
    clickChoose() {
      this.choose = !this.choose;
    },
    isWechatBrowser() {
      var ua = navigator.userAgent.toLowerCase();
      var isWeixin = ua.indexOf("micromessenger") !== -1;
      return isWeixin;
    },
    goPay() {
      if (!this.isClickPay) {
        this.isClickPay = true;
        if (this.isWechatBrowser()) {
          wechat();
        } else {
          this.$toast("请在微信中访问页面进行支付");
          this.isClickPay = false;
        }
      }
      // this.$router.push("/order/orderresult");
    },
  },
};
</script>

<style lang="less" scoped>
.title_right {
  width: 36px;
}
.pay_con {
  background: #fff;
  position: absolute;
  top: 48px;
  left: 0;
  right: 0;
  bottom: 0;
  .pay_type {
    border-top: 4px solid rgba(246, 247, 248, 1);
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 17px 12px;
    font-size: 0;
    .wechat_icon {
      width: 24px;
      margin-right: 12px;
      vertical-align: middle;
    }
    .select_icon {
      display: block;
      width: 18px;
    }
    .wechat_font {
      vertical-align: middle;
    }
  }
  .save_btn {
    position: fixed;
    bottom: 8px;
    right: 0;
    left: 0;
    margin: 13px 12px 0;
    background: linear-gradient(90deg, #e1c49d 0%, #bf9264 100%);
    border-radius: 2px;
    padding: 14px 0;
  }
}
</style>
